import { Text } from 'react-native';
import createAnimatedComponent from '../../createAnimatedComponent';
const AnimatedText = createAnimatedComponent(Text);
export default AnimatedText;
